import React from "react";
// new product development
const newProduct1 = require("../assets/PRODUCT_DESIGN/bottle_basket_01.jpg");
const newProduct2 = require("../assets/PRODUCT_DESIGN/FINAL_BASKET_LID_DESIGN0123456.jpg");
const newProduct3 = require("../assets/PRODUCT_DESIGN/MAIN_PAGE_IMAGE_2.jpg");

// reverse engineering
const reverse1 = require("../assets/REVERSE_ENGINEERING/20170617-200029-009.png");
const reverse2 = require("../assets/REVERSE_ENGINEERING/20170617-200601-013.png");
const reverse3 = require("../assets/REVERSE_ENGINEERING/20170617-202125-021.png");
const reverse4 = require("../assets/REVERSE_ENGINEERING/20170617-202519-022.png");
const reverse5 = require("../assets/REVERSE_ENGINEERING/NX_DATA_SOLID12.png");

// DOMAIN
const domain1  = require("../assets/SIEMENS_NX_TRAINING/20200731-145149-001.png");
const domain2 = require("../assets/SIEMENS_NX_TRAINING/20200731-145727-002.png");
const domain3 = require("../assets/SIEMENS_NX_TRAINING/20200731-151027-003.png");
const domain4 = require("../assets/SIEMENS_NX_TRAINING/20200731-152430-004.png");


//seimens  seimens1
const seimens1 = require("../assets/DOMAIN_TRAINING/20200523-161731-013.png");
const seimens2 = require("../assets/DOMAIN_TRAINING/20200523-163008-001.png");
const seimens3 = require("../assets/DOMAIN_TRAINING/20200523-164326-004.png");
const seimens4 = require("../assets/DOMAIN_TRAINING/20200523-165409-007.png");


// inhouse
const inhouse1 = require("../assets/IN_HOUSE_PROJECTS/20200507-182640-001a.png");
const inhouse2 = require("../assets/IN_HOUSE_PROJECTS/Assembly_exploded_.PNG");
const inhouse3 = require("../assets/IN_HOUSE_PROJECTS/SAFETY_GOGGLE_BYMEDO_2105_stp011101.png");

// staffing solution
const staffing1 = require("../assets/STAFFING_SOLUTION/STAFFING_SOLUTION.jpg");
const staffing2 = require("../assets/STAFFING_SOLUTION/STAFFING_SOLUTION1.jpg");
const staffing3 = require("../assets/STAFFING_SOLUTION/STAFFING_SOLUTION2.jpg");

//comming soon
const comming_1 = require("../assets/commin_soon/IMG_3055.JPG");
const comming_2 = require("../assets/commin_soon/IMG_3061.JPG");
const comming_3 = require("../assets/commin_soon/WP_20170507_003.jpg");
const comming_4 = require("../assets/commin_soon/WP_20170514_002.jpg");

//UX/UI
const screen_shot_1 = require("../assets/UX_UI/Screen_Shot_1.png");
const screen_shot_2 = require("../assets/UX_UI/Screen_Shot_2.png");
const screen_shot_3 = require("../assets/UX_UI/Screen_Shot_3.png");
const screen_shot_4 = require("../assets/UX_UI/Screen_Shot_4.png");
const screen_shot_5 = require("../assets/UX_UI/Screen_Shot_5.png");
const screen_shot_6 = require("../assets/UX_UI/Screen_Shot_6.png");

const Services = () => {
  return (
    <>
    <div className="row" style={{ padding: "5px" }}></div>
    <div className="container">
      <div className="padd-bottom">
        <div className="card col-md-4 card-body text-justify card-border-r">
          <h3 style={{ textAlign: "center" }} className="poppins-bold m-0">
            Services We Provide
          </h3>
        </div>
      </div>

      {/* 1 st row */}
      <div className="display-flex services-flex-column">
        <div className="display-flex services-1 tras-out services-flex-column">
          <div>
            <div className="clip-path">
              <div
                id="carousel1"
                className="carousel slide h-100"
                data-ride="carousel"
              >
                <div className="carousel-inner h-100">
                  <div className="carousel-item h-100 active">
                    <img
                      className="d-block w-100 h-100"
                      src={newProduct1}
                      alt="new Product Design"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={newProduct2}
                      alt="new Product Design"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={newProduct3}
                      alt="new Product Design"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="service-font txt-align">
              <p className="m-1 font-bold-700">NEW</p>{" "}
              <p className="m-1 font-bold-700">PRODUCT</p>{" "}
              <p className="m-1 font-bold-700">DEVELOPMENT</p>
            </div>
          </div>

          <div className="clip-path-txt align-clip-path clip_path_pos">
            <div className="hexa-text">
              <p className="m-0">We Provide New</p>
              <p className="m-0">Product Design</p>
              <p className="m-0">Solutions for sectors</p>
              <p className="m-0">like automotive,</p>
              <p className="m-0">medical, packaging</p>
              <p className="m-0">design and household</p>
              <p className="m-0">products/ goods</p>
              <p className="m-0">design.</p>
            </div>
          </div>
        </div>

        <div className="display-flex services-2 tras-out services-flex-column padd_top_sm">
          <div>
            <div className="clip-path">
              <div
                id="carousel2"
                className="carousel slide h-100"
                data-ride="carousel"
              >
                <div className="carousel-inner h-100">
                  <div className="carousel-item h-100 active">
                    <img
                      className="d-block w-100 h-100"
                      src={reverse1}
                      alt="Reverse Engg"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={reverse2}
                      alt="Reverse Engg"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={reverse3}
                      alt="Reverse Engg"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={reverse4}
                      alt="Reverse Engg"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={reverse5}
                      alt="Reverse Engg"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="service-font txt-align">
              <p className="m-1 font-bold-700">REVERSE</p>{" "}
              <p className="m-1 font-bold-700">ENGINEERING</p>{" "}
            </div>
          </div>

          <div className="clip-path-txt align-clip-path clip_path_pos">
            <div className="hexa-text">
              <p className="m-0">We Provide Parametric</p>
              <p className="m-0">CAD model or surface</p>
              <p className="m-0">model as per client</p>
              <p className="m-0">requirements from</p>
              <p className="m-0">scanned components.</p>
            </div>
          </div>
        </div>
      </div>

      {/* 2 st row */}
      <div className="display-flex hex-top services-flex-column">
        <div className="display-flex services-3 tras-out services-flex-column">
          <div>
            <div className="clip-path">
              <div
                id="carousel3"
                className="carousel slide h-100"
                data-ride="carousel"
              >
                <div className="carousel-inner h-100">
                  <div className="carousel-item h-100 active">
                    <img
                      className="d-block w-100 h-100"
                      src={domain1}
                      alt="Siemens Nx Training"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={domain2}
                      alt="Siemens Nx Training"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={domain3}
                      alt="Siemens Nx Training"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={domain4}
                      alt="Siemens Nx Training"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="service-font txt-align">
              <p className="m-1 font-bold-700">SIEMENS NX</p>{" "}
              <p className="m-1 font-bold-700">TRAINING</p>
            </div>
          </div>

          <div className="clip-path-txt align-clip-path clip_path_pos">
            <div className="hexa-text">
              <p className="m-0">Detailed SIEMENS NX</p>
              <p className="m-0">training from SKETCHER,</p>
              <p className="m-0">SOLID MODELING,</p>
              <p className="m-0">SURFACING, ASSEMBLY,</p>
              <p className="m-0">PMI, DRAFTING</p>
            </div>
          </div>
        </div>

        <div className="display-flex services-4 tras-out services-flex-column padd_top_sm">
          <div>
            <div className="clip-path">
              <div
                id="carousel41"
                className="carousel slide h-100"
                data-ride="carousel"
              >
                <div className="carousel-inner h-100">
                  <div className="carousel-item h-100 active">
                    <img
                      className="d-block w-100 h-100"
                      src={seimens1}
                      alt="Domain Training"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={seimens2}
                      alt="Domain Training"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={seimens3}
                      alt="Domain Training"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={seimens4}
                      alt="Domain Training"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="service-font txt-align">
              <p className="m-1 font-bold-700">DOMAIN</p>{" "}
              <p className="m-1 font-bold-700">TRAINING</p>
            </div>
          </div>

          <div className="clip-path-txt align-clip-path clip_path_pos">
            <div className="hexa-text">
              <p className="m-0">Detailed Training on</p>
              <p className="m-0">domain consists of</p>
              <p className="m-0">CAD Methodologies,</p>
              <p className="m-0">Concept Development,</p>
              <p className="m-0">Finalizing Design,</p>
              <p className="m-0">Detailing.</p>
            </div>
          </div>
        </div>
      </div>

      {/* 3rd row */}
      <div className="display-flex hex-top services-flex-column">
        <div className="display-flex services-5 tras-out services-flex-column">
          <div>
            <div className="clip-path">
              <div
                id="carousel44"
                className="carousel slide h-100"
                data-ride="carousel"
              >
                <div className="carousel-inner h-100">
                  <div className="carousel-item h-100 active">
                    <img
                      className="d-block w-100 h-100"
                      src={staffing1}
                      alt="Staffing Solution"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={staffing2}
                      alt="Staffing Solution"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={staffing3}
                      alt="Staffing Solution"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="service-font txt-align">
              <p className="m-1 font-bold-700">STAFFING</p>{" "}
              <p className="m-1 font-bold-700">SOLUTIONS</p>
            </div>
          </div>

          <div className="clip-path-txt align-clip-path clip_path_pos">
            <div className="hexa-text" style={{ padding: "20px" }}>
              <p className="m-0">Engineers on contract</p>
              <p className="m-0">basis for Automotive</p>
              <p className="m-0">and other design</p>
              <p className="m-0">industries</p>
            </div>
          </div>
        </div>

        <div className="display-flex services-6 tras-out services-flex-column padd_top_sm">
          <div>
            <div className="clip-path">
              <div
                id="carousel5"
                className="carousel slide h-100"
                data-ride="carousel"
              >
                <div className="carousel-inner h-100">
                  <div className="carousel-item h-100 active">
                    <img className="d-block w-100 h-100" src={inhouse1} alt="IN-HOUSE PROJECT"/>
                  </div>
                  <div className="carousel-item h-100">
                    <img className="d-block w-100 h-100" src={inhouse2} alt="IN-HOUSE PROJECT"/>
                  </div>
                  <div className="carousel-item h-100">
                    <img className="d-block w-100 h-100" src={inhouse3} alt="IN-HOUSE PROJECT"/>
                  </div>
                </div>
              </div>
            </div>
            <div className="service-font txt-align">
              <p className="m-1 font-bold-700">IN-HOUSE</p>{" "}
              <p className="m-1 font-bold-700">PROJECTS</p>
            </div>
          </div>

          <div className="clip-path-txt align-clip-path clip_path_pos">
            <div className="hexa-text">
              <p className="m-0">Capability of Designing</p>
              <p className="m-0">Automotive</p>
              <p className="m-0">components in </p>
              <p className="m-0">versatile domain like</p>
              <p className="m-0">Interior-Exterior Trims,</p>
              <p className="m-0">Seating Systems and</p>
              <p className="m-0">BIW Components.</p>
            </div>
          </div>
        </div>
      </div>

      {/* 4th row */}
      <div className="display-flex hex-top services-flex-column">
        <div className="display-flex services-7 tras-out services-flex-column">
          <div>
            <div className="clip-path">
              <div
                id="carousel9"
                className="carousel slide h-100"
                data-ride="carousel"
              >
                <div className="carousel-inner h-100">
                  <div className="carousel-item h-100 active">
                    <img
                      className="d-block w-100 h-100"
                      src={comming_1}
                      alt="In Training & Services"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={comming_2}
                      alt="In Training & Services"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={comming_3}
                      alt="In Training & Services"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={comming_4}
                      alt="In Training & Services"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="service-font txt-align">
              <p className="m-1 font-bold-700">Comming Soon...</p>
              <p className="m-1 font-bold-700">In Training & Services</p>
            </div>
          </div>

          <div className="clip-path-txt align-clip-path clip_path_pos">
            <div className="hexa-text" style={{ padding: "20px" }}>
              <p className="m-0">Plastic Injection Mold Tool Design</p>
              <p className="m-0">
                Aluminum Die Casting and Green Sand Molding Tools
              </p>
              <p className="m-0">Clay Modeling</p>
            </div>
          </div>
        </div>

        <div className="display-flex services-8 tras-out services-flex-column padd_top_sm">
          <div>
            <div className="clip-path">
            <div
                id="carousel999"
                className="carousel slide h-100"
                data-ride="carousel"
              >
                <div className="carousel-inner h-100">
                  <div className="carousel-item h-100 active">
                    <img
                      className="d-block w-100 h-100"
                      src={screen_shot_1}
                      alt="UX / UI"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={screen_shot_2}
                      alt="UX / UI"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={screen_shot_3}
                      alt="UX / UI"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={screen_shot_4}
                      alt="UX / UI"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={screen_shot_5}
                      alt="UX / UI"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      className="d-block w-100 h-100"
                      src={screen_shot_6}
                      alt="UX / UI"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="service-font txt-align">
              <p className="m-1 font-bold-700">UX / UI</p>              
            </div>
          </div>

          <div className="clip-path-txt align-clip-path clip_path_pos">
            <div className="hexa-text">              
              <p className="m-0">Software Development as per product requirements</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Services;
